import { ErrorOutline } from '@mui/icons-material';
import { Box, Paper, Typography, SxProps, Theme } from '@mui/material';

interface SinDatosProps {
  title?: string;
  subtitle?: string;
  sx?: SxProps<Theme>;
}

export const SinDatos = ({
  title = "No se encontraron datos",
  subtitle = "Intenta ajustar los filtros o crear un nuevo registro.",
  sx
}: SinDatosProps) => {
  return (
    <Paper
      elevation={0}
      sx={{
        mt: 10,
        p: 4,
        borderRadius: 3,
        border: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        background: 'linear-gradient(to bottom right, #fafafa, #ffffff)',
        ...sx,
      }}
    >
      <Box>
        <ErrorOutline sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />

        <Typography variant="h6" fontWeight={600} sx={{ mb: 1 }} color="text.primary">
          {title}
        </Typography>

        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      </Box>
    </Paper>
  );
};
